// extracted by mini-css-extract-plugin
module.exports = {"shipmentDetails":"yG","trackingProgress":"zG","steps":"AG","step":"BG","stepComplete":"CG","stepActive":"DG"};